import { render, staticRenderFns } from "./HdsListItem.vue?vue&type=template&id=60ce90b6&scoped=true&"
import script from "./HdsListItem.vue?vue&type=script&lang=ts&"
export * from "./HdsListItem.vue?vue&type=script&lang=ts&"
import style0 from "./HdsListItem.vue?vue&type=style&index=0&id=60ce90b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce90b6",
  null
  
)

export default component.exports